import e3WebRTC from './e3WebRTC';
// import TokBox from './plugin/TokBox';
import ChatService from '../service/chat/e3.viewer.chat.service';
import HelpService from '../service/help.service';
import DetectService from '../service/e3.viewer.detect.service';
import { RealtimeVideo } from './modules/realtime-video';
import * as env from './modules/helper';
const debounce = require('lodash/debounce');
const isEqual = require('lodash/isEqual');
import {TOKBOX, SCREEN_SHARE, publishKey} from 'a_root-folder/constants';
import {showCreatedModalBrokenWebrtc, waitForPhoneNumber, connectViaPhone} from 'a_root-folder/lib/service/modal/templates/brokenWebrtc';
import EventEmmiter from "../helpers/EventEmmiter";
import LeadGeneration from 'a_root-folder/lib/lead-generation';
import {servInstance, delay} from 'a_root-folder/lib/helpers/common';
import {checkE3liveRestrictions, closeConnection, connectToServer, e3liveRestrictions} from "service/socket";

require('./realtime.scss');

export default class Realtime extends EventEmmiter {
    constructor(TranslateService, e3live_idle) {
        super();
        this._helpService = new HelpService();
        this._ably = null;
        this._channel = null;
        this._presence = null;
        this._roomID = null;
        this._container = null;
        this.agents = [];
        this._uuidUser = null;
        this._status = null;
        this._currentTourPosition = null;
        this._enableWebRTC = false;
        this.waitForAgent = null;
        this._peerVideos = {};
        this._userUUIDS = [];
        this.max_call_duration = null;
        this.max_call_duration_timer = null;
        this._agentPhone = null;
        this._e3PluseButton = document.getElementsByClassName('control-e3livePlus')[0];
        this.downtime = null;
        this.downtimeInterval = null;
        this._userAgent = null;
        this._timeStamp = new Date().getTime();
        this._audio = this._helpService.getAudioContext();
        this._permissions = this._helperService.getPermissions();
        this._enableConsoleLog = this._permissions['debug'];
        this._starRTC = true;
        this._e3live_idle = e3live_idle;
        this._waitForPhoneNumber = false;
        this._location = this._helpService.location;
        this._translateService = TranslateService;
        this._translate = TranslateService.translate.bind(TranslateService);
        this._callWithAgent = this._location.href.match(/sharelink=0/i);
        this._userUUIDSWithoutVideo = [];
        this._onPhoneCall = false;
        this._groupIDs = config.groupIDs;
        this._agentRoomID = servInstance + config.agent.companyID;
        this._urlParams = this._helperService.urlParams;
        this._hideLeadGeneration = this._urlParams['lead_gen']  === 'true' ? false  : true;
        this._erroModal = () => {};
    }

    inIframe () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    init = async (container, roomID, config, {tokbox}) => {
        this._initChatService(container);

        this._container = container;
        this._roomID = roomID;
        this.e3live_provider = {};
        this.patchFunctions();
        this.publishKey = publishKey;
        this.screenShare = null;

        this.max_call_duration = config.priceplan.max_call_duration * 1000;
        this.tourName = config.title;
        this._agentPhone = this.parse_url(window.location.search.substring(1)).phone;
        this._withoutvideo = this.parse_url(window.location.search.substring(1)).withoutvideo;

        this._hideE3livePlus();
        this._addEventListners();

        const {ably,channel, presence, uuidUser} = connectToServer(this._roomID)
        this._ably  = ably;
        this._channel = channel;
        this._presence = presence;
        this._uuidUser = uuidUser;

        try{
            const restriction = await checkE3liveRestrictions(this._channel, config);
            if(restriction.length) {
                closeConnection(ably)
                return this._modalService.alertModal(
                    restriction,
                    this._redirectToTour
                );
            }
        }catch (e){
            return this._modalService.alertModal(
                e,
                this._redirectToTour
            );
        }

        this._realtimeVideo = new RealtimeVideo(this._container, this._uuidUser, this._audio);

        if (!this._checkWebRTCCapabilities()) return;

        this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'starting'});

        if (!this.hasWebcam || !this.isWebsiteHasWebcamPermissions || !this._isSupportRTC) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'start'});
        }

        if (this._callWithAgent) this._waitForAgentAnswer();

        this._addDebounceActions();
        this._subscribeToRoom();
        this._stateListener();
        this._msgListener();
    }

    patchFunctions(){
        switch (this.e3live_provider.type) {
            case TOKBOX:
                this.tokBoxUpdate();
                break;

            default:
        }
    }

    tokBoxUpdate(){
        this._addVideoBlock = (occupants) => {
            let id = occupants.clientId;
            const hasWebcam = occupants.data.hasWebcam;
            if(hasWebcam === false){
                return this._addBlock(occupants);
            }
            this._userUUIDSWithoutVideo.push(id);
            console.log(id)
        };

        this._continueFromPhone = (modalName) => {
            this._modalService.close(modalName);
            this._showBlockPhoneNumber();

            patchContinueWithoutVideo();
        }

        const patchContinueWithoutVideo = () => {
            this._addVideoBlock = (occupants) => {
                this._addBlock(occupants);
            };

            this._userUUIDSWithoutVideo.forEach((id) => {
                this._addVideoBlock({clientId: id});
            })

            if (this._modalService.checkIfModalPresent('share')) {
                this._modalService.close('share');
            }
            this._chatService.show();
        }
    }

    send(type, data) {
        switch(type) {
            case 'e3-viewer':
                this._getE3ViewerData(data);
                break;
        }
    }

    _addDebounceActions(){
        this._touchingBlockedDebounce = debounce(() => {
            this.viewer.hideBlockScreen();
            this._realtimeVideo.updatesAllUserStates();
            this._touchingBlocked = false;
            this._userAgent = null;
        }, 3000);
        this._movingBlockedDebounce = debounce(() => {
            this._movingBlocked = false;
            this._realtimeVideo.updatesAllUserStates()
        }, 3000);
    }

    _initChatService(container) {
        this._chatService = new ChatService();
        this._chatService.init(container);
        this._chatService.on('e3-chat-send', (value) => {
            if (!value) return;

            this._channel.publish('message', {
                channel: this._roomID,
                message: {
                    code: 'message',
                    data: {userID: this._uuidUser, msg: value, timestamp: new Date().toISOString()}
                }
            }, this._stillHere.bind(this));
        })
    }

    _subscribeToRoom() {
        this._channel.attach((err) => {
            if (err) {
                return console.error("Error attaching to the channel");
            }

            this._channel.presence.enter({
                webRTCSupportClient: this._isSupportRTC,
                timestamp: new Date().getTime(),
                hasWebcam: this.hasWebcam && this.isWebsiteHasWebcamPermissions
            }, (err) => {
                if (err) {
                    return console.error("Error entering presence");
                }

               try {
                   this._runWebRTC();
               }catch (e) {
                    console.error(e)
               }
            });
        });

        this._channel.presence.get((err, members) => {
            let occupants = members.filter(({clientId}) => clientId !== this._uuidUser);

            if (occupants.length > 0) {
                let i = occupants.length;
                while (i--) {
                    this._addVideoBlock(occupants[i]);
                }
                this._stillHere();
            }
        });
    }

    _stateListener() {
        this._presence.subscribe((e) => {
            if (e.action === "enter") {
                this._stateOnEnter(e);
            }
            if (e.action === "leave" && e.clientId !== this._uuidUser) {
                this._stateOnLeave(e)
            }

            this._checkUserUUIDsLength();
        });
    }

    _stateOnEnter(e) {
        if(e.clientId === `${SCREEN_SHARE}_${this._uuidUser}`) {
            const id = `${SCREEN_SHARE}_${this._uuidUser}`

            this._realtimeVideo.add(id, {classList: ['video-tag-agent', id], state: 2, onBrokeStream: this._onBrokenStream.bind(this)});
            this._realtimeVideo.addStream(id, this.screenShare.stream);

            this._userUUIDS.push(id);

            return ;
        }

        if (e.clientId === this._uuidUser && this._userUUIDS.length > 0) {
            this._hideWaitForAgentAnswer();
            if (this._callWithAgent && this._agentPhone) {
                let country = this._agentPhone.slice(0, 2);
                let city = this._agentPhone.slice(2, 5);
                let numberfirst = this._agentPhone.slice(5, 8);
                let numbersecond = this._agentPhone.slice(8, this._agentPhone.length);

                this._chatService._sendMsg({keyCode: 13}, this._translate('VOICE_CHAT') + '  <a href="tel:' + this._agentPhone + '">+' + country + '(' + city + ')' + numberfirst + '-' + numbersecond + '</a>');
            }
        } else if (e.clientId !== this._uuidUser) {
            this._hideWaitForAgentAnswer();
            this._addVideoBlock(e);
            this._timeStamp = new Date().getTime();
            this._channel.publish('message', {
                channel: this._roomID,
                message: {
                    code: 'e3-viewer-first-load',
                    data: this.viewer.getCurrentPosition(),
                    userID: this._uuidUser,
                }
            });
        }

        this._stillHere();
    }

    _stateOnLeave(e) {
        if (e.data && e.data.maxCallDuration) {
            this._leaveChanel();

            clearTimeout(this.max_call_duration_timer);

            this._clearExpireTime();
            this._chatService.hide();
            this._hideE3livePlus();
        }

        this._removeVideoBlock(e.clientId);
    }

    _checkUserUUIDsLength() {
        if (this._userUUIDS.length < 1) {
            clearTimeout(this.max_call_duration_timer);
            this._clearExpireTime();
            if(this._modalService.checkIfModalPresent('connect-via-phone') ||
                this._modalService.checkIfModalPresent('broken-webrtc') ||
                this._waitForPhoneNumber){

                return ;
            }

            if (!this._modalService.checkIfModalPresent('alert') &&
                !this._modalService.checkIfModalPresent('agent_call') &&
                !this._modalService.checkIfModalPresent('lead-generation')) {
                this._modalService.createSocialShare(this._shareModalClose.bind(this));
            }

            this._chatService.hide();
            this._hideE3livePlus();
        } else {
            if (this.max_call_duration) {
                this.max_call_duration_timer = setTimeout(() => {
                    this._leaveChanel(false);
                }, this.max_call_duration)
            }

            this._modalService.close('share');
            this._chatService.show();
            this._showE3livePlus();
            this._erroModal();
        }
    }

    _leaveChanel(silent = true) {

        // ... leave chanel (silent mb)
        // ... remove all agents blocks
        // ... print modal stuff

        this._presence.leave({maxCallDuration: !silent});
        this._removeAllAgentsBlocks();
        this._modalService.alertModal(
            'MAX_CALL_DURATION_MESSAGE',
            this._redirectToTour
        );
    }

    _checkWebRTCCapabilities() {
        if (this._enableWebRTC) return;

        if (env.isIosChrome) {
            this._modalService.close('share');
            this._chatService.hide();
            let template = '<p>' + this._translateService.translate('E3_LIVE_IOS_CHROME_ERROR_DESCR') + '</p>' +
                '<div id="copy" class="inviteUrl"><input type="text" class="copy-url" value="' + this._location.href + '"/><span class="copy copy-icon"></span></div>';

            this._modalService.showCreatedModal('alert', template, true, {
                'copy': this._helpService.copyToClipboard.bind(null, 'e3-viewer-modal', 'copy', this._location.href)
            });

            return;
        }
        if (env.isFBApp) {
            let message = env.isiOS ? this._modalService.prepareVWMessage('ios_fb', 'e3live') : this._modalService.prepareVWMessage('android_fb', 'e3live');
            this._modalService.close('share');
            this._chatService.hide();
            this._modalService.showCreatedModal('alert', message, true);

            return;
        } else if (env.isWebView) {
            this._modalService.close('share');
            this._chatService.hide();
            this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('android_wv', 'e3live'), true);

            return;
        } else if (env.isIosWebView) {
            this._modalService.close('share');
            this._chatService.hide();
            this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('ios_wv', 'e3live'), true);

            return;

        } else if (!this._isSupportRTC || env.isOperaMini || env.isIosChrome || env.isMiuiBrowser) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'rtc_not_supported'});
            if (!this._withoutvideo) {
                this._erroModal = this._useTheseBrowserModal.bind(this);
            }

            return true;
        } else if (this._isSupportRTC && !this.isWebsiteHasWebcamPermissions && !this.isWebsiteHasMicrophonePermissions) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'rtc_not_supported'});
            this._erroModal = this._continueWithoutVideoAndMicrophoneModal.bind(this);

            return true;
        } else if (this._isSupportRTC && (!this.isWebsiteHasMicrophonePermissions)) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'rtc_not_supported'});
            this._erroModal = this._continueWithoutMicrophoneModal.bind(this);

            return true;
        } else if (this._isSupportRTC && (!this.isWebsiteHasWebcamPermissions)) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'rtc_not_supported'});
            this._erroModal = this._continueWithoutVideoModal.bind(this);

            return true;
        }

        return true;
    }

    _continueWithoutMicrophoneModal() {
        this._modalService.close('share');
        let template = '<p>' + this._translate('ENABLE_YOUR_MICROPHONE') + '  <a class="link" href="' + this._location.href + '">' + this._translate('RETRY') + '</a></p><p>' + this._translate('DONOT_HAVE_MICROPHONE') + ' <a class="link" id="close-info-block">' + this._translate('CONTINUE_FROM_PHONE') + '</a></p>';
        this._modalService.showCreatedModal('alert', template, true, {
            'close-info-block': {event: 'click', handler: this._continueFromPhone.bind(this, 'alert')}
        });
        this._erroModal = () => {};
    }

    _continueWithoutVideoAndMicrophoneModal() {
        this._modalService.close('share');
        let template = '<p>' + this._translate('ENABLE_YOUR_CAMERA_AND_MICROPHONE') + '  <a class="link" href="' + this._location.href + '">' + this._translate('RETRY') + '</a></p><p>' + this._translate('DONOT_HAVE_MICROPHONE_AND_CAMERA') + ' <a class="link" id="close-info-block">' + this._translate('CONTINUE_FROM_PHONE') + '</a></p>';
        this._modalService.showCreatedModal('alert', template, true, {
            'close-info-block': {event: 'click', handler: this._continueFromPhone.bind(this, 'alert')}
        });
        this._erroModal = () => {};
    }

    _continueWithoutVideoModal() {
        this._modalService.close('share');
        let template = '<p>' + this._translate('ENABLE_YOUR_CAMERA') + '  <a class="link" href="' + this._location.href + '">' + this._translate('RETRY') + '</a></p><p>' + this._translate('DONOT_HAVE_CAMERA') + ' <a class="link" id="close-info-block">' + this._translate('CONTINUE_WITHOUT_VIDEO') + '</a></p>';
        this._modalService.showCreatedModal('alert', template, true, {
            'close-info-block': {event: 'click', handler: this._continueWithoutCamera.bind(this, 'alert')}
        });
        this._erroModal = () => {};
    }

    _useTheseBrowserModal() {
        this._modalService.close('share');
        let template = '<p>' + this._translate('USE_ONE_OF_THESE_BROWSER') + '</p><p><table style="margin-left:auto; margin-right:auto"> <tbody><tr class="browsers"> <th><img src="https://www.eyespy360.com/common/images/browser_logos/chrome.png" alt="Chrome" title="Chrome"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/firefox.png" alt="Mozilla Firefox" title="Mozilla Firefox"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/edge.png" alt="Edge" title="Edge"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/safari.png" alt="Safary" title="Safary"></th> </tr><tr class="versions"> <th>Chrome 60</th> <th>Firefox 55</th> <th>Edge 40</th> <th>Safari 11</th> </tr></tbody></table></p><p>or <a class="link" id="close-info-block">' + this._translate('CONTINUE_FROM_PHONE') + '</a></p>';
        this._modalService.showCreatedModal('alert', template, true, {
            'close-info-block': {event: 'click', handler: this._continueFromPhone.bind(this, 'alert')}
        });
        this._erroModal = () => {};
    }

    _continueWithoutCamera(modalName) {
        this._modalService.close(modalName);
    }

    _continueFromPhone(modalName) {
        this._modalService.close(modalName);

        this._showBlockPhoneNumber();

        // if (this._userUUIDS < 1) {
        //     this._modalService.createSocialShare(this.__socialModalClose.bind(this));
        // }
    }

    _runWebRTC() {
        // if (!this._isSupportRTC || !this.isWebsiteHasWebcamPermissions || !this.isWebsiteHasMicrophonePermissions) {
        if (!this._isSupportRTC || !this.isWebsiteHasMicrophonePermissions) {
            this._realtimeVideo.setState(this._uuidUser, 'playing');
            this._realtimeVideo.setState('empty', 'playing');

            return;
        }

        this._enableWebRTC = true;

        this.installWebRTCProvider();

        this._channel.subscribe('message', (res) => {
            let data = res.data;

            if (data.message.to === this._uuidUser) {
                this.setContainers();
                this._e3WebRTC.sendRTCData(res);
            }

            if (data.message.to === `${SCREEN_SHARE}_${this._uuidUser}`) {
                if(!res.data.publisher.match(/SCREEN_SHARE/)) res.data.publisher = `${SCREEN_SHARE}_${res.data.publisher}`;

                if(this.screenShare) this._e3WebRTC.sendRTCData(res, this.screenShare.stream);

                if(!this.screenShare) this._e3WebRTC.sendRTCData(res);
            }
        });

        this._presence.subscribe((e) => {
            if (e.action === "enter" && e.clientId !== this._uuidUser && e.clientId !== `${SCREEN_SHARE}_${this._uuidUser}`) {
                this.setContainers();
                this._e3WebRTC.connectToPeer(e.clientId, true);
            }
            if (e.action === "leave" && e.clientId !== this._uuidUser) {
                this._e3WebRTC.leavePeer(e.clientId);
            }

            if (e.action === "enter" && e.clientId.match(/SCREEN_SHARE/)) {
                this._fireEvent('e3-viewer-screen-sharing', true);
            }

            if (e.action === "leave" && e.clientId.match(/SCREEN_SHARE/)) {
                this._fireEvent('e3-viewer-screen-sharing', false);
            }
        });

        this._e3WebRTC.on('e3-webrtc-remove-peer', (peerID) => this._removeVideoBlock(peerID, this._onPhoneCall));
        this._e3WebRTC.on('e3-webrtc-add-local-camera', (stream) => this._realtimeVideo.addStream(this._uuidUser, stream));
        this._e3WebRTC.on('e3-webrtc-codec-error', (err) => this._showBlockPhoneNumber(err.message));
        this._e3WebRTC.on('e3-webrtc-send-invite-data', (message) => this._webRTCSendInviteData(message));
        this._e3WebRTC.on('e3-webrtc-on-track', (evt, peerID) => this._webRTCOnTrack(evt, peerID));

        this._e3WebRTC.on('e3-webrtc-hide-share', () => this._hideShare());
        this._e3WebRTC.on('e3-webrtc-on-playing', (peerID) => this._setStatus(peerID));
        this._e3WebRTC.on('e3-webrtc-add-video-block', (clientId) => this._addVideoBlockFromStream({clientId}));
        // this._e3WebRTC.on('e3-webrtc-add-stream', () => this._realtimeVideo.addStream(clientId, stream));
    }

    isScreenSharing() {
        return this._userUUIDS.filter((id) => id.match(/SCREEN_SHARE/)).length && !this.screenShare;
    }

    addScreenStream(stream) {
        this.screenShare = {};

        const {ably,channel, presence} = connectToServer(this._roomID, `${SCREEN_SHARE}_${this._uuidUser}`)
        this.screenShare.ably  = ably;
        this.screenShare.channel = channel;
        this.screenShare.presence = presence;

        this.screenShare.stream = stream;

        this.screenShare.channel.attach((err) => {
            if (err) {
                return console.error("Error attaching to the channel");
            }

            this.screenShare.channel.presence.enter({
                webRTCSupportClient: this._isSupportRTC,
                timestamp: new Date().getTime(),
                hasWebcam: this.hasWebcam && this.isWebsiteHasWebcamPermissions
            }, (err) => {
                if (err) {
                    return console.error("Error entering presence");
                }
            });
        });

        this.screenShare.presence.subscribe((e) => {
            if (e.action === "enter" && e.clientId !== `${SCREEN_SHARE}_${this._uuidUser}`) {
                this._e3WebRTC.connectToPeer(`${SCREEN_SHARE}_${e.clientId}`, true, this.screenShare.stream);
            }
            if (e.action === "leave" && e.clientId !== this._uuidUser) {
            }
        });
    }

    exitFromScreenShareE3Live() {
        this.screenShare.stream.getTracks().forEach(track => { if(track.kind === 'video') track.stop()});
        this.screenShare.presence.leave();
        this.screenShare = null;
        this._e3WebRTC.removeScreenSharePeer();
    }

    installWebRTCProvider(){
        switch (this.e3live_provider.type) {
            // case TOKBOX:
            //     this._e3WebRTC = new TokBox(this.e3live_provider);
            //     this._e3WebRTC.setUuidUser(this._uuidUser);
            //     break;

            default:
                this._e3WebRTC = new e3WebRTC(this._local_stream, this._permissions);
        }
    }

    setContainers(){
        if(this.e3live_provider.type === TOKBOX){
            const containers = this._realtimeVideo.getContainer();
            this._e3WebRTC.setContainers(containers);
        }
    }

    _setStatus(peerID){
        this._realtimeVideo.setState(peerID, 'playing');
    }

    _webRTCSendInviteData(message) {
        this._channel.publish('message', {
            channel: this._roomID,
            publisher: this._uuidUser,
            message: message
        }, () => { /* ... */ });
    }

    _hideShare() {
        this._modalService.close('share');
    }

    _webRTCOnTrack(evt, peerID) {
        this._logger("%c%s WebRTCOnTrack - %s", 'color: blue', new Date(), peerID);
        this._logger("%c%s isPlaying - %s", 'color: blue', new Date(), this._realtimeVideo.isPlaying(peerID));
        this._logger("%c%s isPresent - %s", 'color: blue', new Date(), this._realtimeVideo.isPresent(peerID));
        if (!this._realtimeVideo.isPresent(peerID)) {
            let occupants = {
                uuid: peerID,
                state: {
                    hasWebcam: true,
                    webRTCSupportClient: true,
                },
            };
            this._addVideoBlock(occupants);
        }

        this._modalService.close('share');
        this._realtimeVideo.addStream(peerID, evt.streams[0]);
        // ... add frame checker when stream was added
        // ... add audio checker when stream was added;
        this._logger("%c%s Add video tag for - %s", 'color: blue', new Date(), peerID);
        if (!this._starRTC) {
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'start_rtc'});
            this._starRTC = true;
        }
    }

    _blockScreen(userID) {
        this._realtimeVideo.setState(userID, 'moving');
        this._touchingBlocked = true;
        this._touchingBlockedDebounce();
        this.viewer.showBlockScreen();
    }

    _msgListener() {
        this._channel.subscribe('message', (data) => {
            let obj = data.data;
            let {code, data: _data, userID} = obj.message;

            const action = {
                'message': () => this._chatService.addMsg(obj, _data.userID === this._uuidUser),
                'send-wait-for-phone-number': () => {
                    this._waitForPhoneNumber = true;
                    if (this._uuidUser !== userID) {
                        this._modalService.showCreatedModal('wait-for-phone-number', waitForPhoneNumber(this._translate('WAIT_FOR_PHONE_NUMBER')), true);
                        this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'pstn_wait'});
                    }
                },
                'send-phone-number': () => {
                    this._waitForPhoneNumber = false;
                    this._onPhoneCall = true;
                    const {phone, isoCode} = obj.message.data.msg;

                    if (this._uuidUser !== userID) {
                        this._modalService.close('wait-for-number');
                        this._modalService.showCreatedModal('connect-via-phone', connectViaPhone(this._translate('CONNECT_VIA_PHONE'), {phone, isoCode}), true);
                        this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'pstn_invite'});
                    }else{
                        this._modalService.close('broken-webrtc');
                    }
                },
                'e3-viewer-block-screen': () => {
                    if (this._uuidUser !== userID) {
                        if (_data){
                            // console.log('get action for blocking from partner')
                            this._blockScreen(userID);
                        }
                    }else if(!this._touchingBlocked){
                        this.viewer.canSendAction();
                        this._realtimeVideo.setState(this._uuidUser, 'moving');
                        this._movingBlocked = true;
                        this._movingBlockedDebounce();
                    }
                    this._stillHere();
                },
                'e3-viewer-first-load': () => {
                    if (this._uuidUser !== userID) {
                        if (_data){
                            this.viewer.hideBlockScreen();
                            this.viewer.moveScene(_data);
                        }
                    }
                },
                'e3-viewer': () => {
                    if (this._uuidUser !== userID && !this._movingBlocked && (this._userAgent == userID || this._userAgent == null)) {
                        if (_data){
                            this._userAgent = userID;
                            // console.log('get action from partner')
                            this._blockScreen(userID);
                            this.viewer.moveScene(_data);
                        }
                    }
                },
                'open-info-modal': () => {
                    if (this._uuidUser !== userID)
                        this._showInfo.call(this._e3context, _data.id, _data.htmlURL, _data.title, _data.icon, _data.div, _data.e, _data.size);
                },
                'e3-viewer-sync-controls': (data) => {
                    if (this._uuidUser !== userID)
                        this._fireEvent('e3-viewer-sync-controls', _data);
                },
                'info-modal-hide': () => {
                    if (this._uuidUser !== userID)
                        this._hideInfoModal.call(this._e3context);
                }
            };

            if (typeof action[code] === 'function') action[code]();
        });
    }

    _unsubscribe() {
        let eventAction = null;

        if ((this.hasWebcam && this.isWebsiteHasWebcamPermissions) && this._isSupportRTC) {
            eventAction = 'end_rtc'
        } else {
            eventAction = 'end'
        }
        return this._sendAnalitics({
            hitType: 'event',
            eventCategory: 'e3live',
            eventAction: eventAction
        }, () => true)
    }

    _showE3livePlus() {
        this._e3PluseButton.classList.remove('hidden');
    }

    _hideE3livePlus() {
        this._e3PluseButton.classList.add('hidden');
    }

    _shareModalClose({shared, copied} = {}) {
        if (this._userUUIDS.length > 0) return true;

        if(shared || copied) {
            this.hangUp(() => {
                this._modalService.close('share');
            });
            return;
        }

        return this._handleFinishCall();
    }

    hangUp(onHangUp) {
        this._modalService.confirm(this._translate('E3_CONFIRM_HANG_UP'), confirmed => {
            this._modalService.close('confirm');
            if(confirmed && this._handleFinishCall() && onHangUp) {
                onHangUp();
            }
        }, '', false);
    }

    _handleFinishCall() {
        this._helpService.redirectToTour();
        return false;
    }

    _addEventListners() {
        this.viewer.on('e3-viewer-send-coord', this._getE3ViewerData.bind(this));
        this.viewer.on('e3-viewer-block-screen', this._blockScreenMsg.bind(this));
        this.viewer.on('open.info', this._getOpenInfoModal.bind(this));
        this.viewer.on('e3-viewer-sync-controls', this._e3ViewerSyncControls.bind(this));
        this.viewer.on('info-modal-hide', this._getHideInfoModal.bind(this));

        window.addEventListener("beforeunload", this._unsubscribe.bind(this));
        window.addEventListener("pagehide", this._unsubscribe.bind(this));
    }

    _blockScreenMsg(data) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'e3-viewer-block-screen',
                data: data,
                userID: this._uuidUser,
            }
        }, this._stillHere.bind(this));
    }

    _getE3ViewerData(data) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'e3-viewer',
                data: data,
                userID: this._uuidUser,
            }
        }, this._stillHere.bind(this));
    }

    _e3ViewerSyncControls(data) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'e3-viewer-sync-controls',
                data,
                userID: this._uuidUser
            }
        }, this._stillHere.bind(this));
    }

    _getOpenInfoModal(id, htmlURL, title, icon, div, e, size) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'open-info-modal',
                data: {
                    id: id,
                    htmlURL: htmlURL,
                    title: title,
                    icon: icon,
                    div: undefined,
                    e: e,
                    size: size,
                },
                userID: this._uuidUser
            }
        }, this._stillHere.bind(this));
    }

    _getHideInfoModal(data) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {code: 'info-modal-hide', data: data, userID: this._uuidUser}
        }, this._stillHere.bind(this));
    }

    _redirectToTour() {
        window.location.href = this._location.href.split('?')[0];
    }

    _hideWaitForAgentAnswer() {
        clearTimeout(this.waitForAgent);
        this.waitForAgent = '';
        if (this._modalService.checkIfModalPresent('agent_call')) {
            this._modalService._removeModal('agent_call');
        }
    }

    _waitForAgentAnswer = async () => {
        if (!this._hideLeadGeneration) {
            this._modalService.showCreatedModal('agent_call', this._translateService.translate('AGENT_CALL'), true);
            await delay(20);
            // if(!this.waitForAgent) return ;
            this._modalService.close('agent_call');
            this._fireEvent('lead-gen-agent-answer', true);
        }else{
            this._modalService.showCreatedModal('agent_call', this._translate('AGENT_CALL'), true);
        }

        this.waitForAgent = setTimeout(this._redirectToTour.bind(this), 120000);
    }

    _stillHere() {
        if (this._userUUIDS.length === 0) return;
        this._clearExpireTime();
        this.downtime = setTimeout(this._showExpireBlock.bind(this), this._e3live_idle);
    }

    _clearExpireTime() {
        if (this.downtime) clearTimeout(this.downtime);
        if (this.downtimeInterval) clearInterval(this.downtimeInterval);
        if (this._modalService.checkIfModalPresent('expire')) {
            this._modalService.close('expire');
        }
    }

    _clearExpireTimer() {
        this._clearExpireTime();
        this._stillHere();
    }

    _showExpireBlock() {
        let i = 30;

        this._modalService.showCreatedModal('expire',
            this._translate('CALL_SESIION_EXPIRE') + ' <span class="expire-interval">' + i + '</span> <button id="expire-interval-clear" class="expire-interval-clear">' + this._translate('STILL_HERE') + '</button>',
            true,
            {
                'chat-modal-close': this._clearExpireTimer.bind(this),
                'expire-interval-clear':  {
                    event: 'click',
                    handler: this._clearExpireTimer.bind(this)
                }
            });

        const expireInterval = document.getElementsByClassName('expire-interval')[0];

        this.downtimeInterval = setInterval(() => {
            expireInterval.innerHTML = i.toString();
            if (i === 0) {
                this._clearExpireTime();
                this._redirectToTour();
            }
            i--;
        }, 1000);
    }

    _removeVideoBlock(uuid, onPhoneCall=false) {
        if(onPhoneCall) return ;
        if (!~this._userUUIDS.indexOf(uuid)) return;

        this._realtimeVideo.remove(uuid);
        this._userUUIDS.splice(this._userUUIDS.indexOf(uuid), 1);

        if (this._userUUIDS.length === 0 && !this._realtimeVideo.isPresent('empty')) {
            this._realtimeVideo.add('empty', {classList: ['video-tag-agent'], state: 1});
            this._checkUserUUIDsLength();
        }
    }

    _removeAllAgentsBlocks() {
        this._userUUIDS.forEach((uuid) => this._removeVideoBlock(uuid))
    }

    _addVideoBlock(occupants) {
        this._addBlock(occupants);
    }

    _addBlock(occupants) {
        let id = occupants.clientId;

        if (this._userUUIDS.length === 0) {
            this._realtimeVideo.remove('empty');
        }

        this._realtimeVideo.add(id, {classList: ['video-tag-agent', id], state: 2, onBrokeStream: this._onBrokenStream.bind(this)});
        this._userUUIDS.push(id);
    }

    _addVideoBlockFromStream(occupants, classes = ['video-tag-agent']) {
        let id = occupants.clientId;

        if (this._userUUIDS.length === 0) {
            this._realtimeVideo.remove('empty');
        }

        this._realtimeVideo.add(id, {classList: classes, state: 2, onBrokeStream: this._onBrokenStream.bind(this)});
        this._userUUIDS.push(id);
        this.setContainers();
        this._chatService.show();
    }

    redirect(url) {
        window.location.href = url;
    }

    _sendPhoneNumber({phone, isoCode}) {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'send-phone-number',
                userID: this._uuidUser,
                data: {msg: {phone, isoCode}, timestamp: new Date().toISOString()}
            }
        }, this._stillHere.bind(this));
    }

    _sendWaitForPhoneNumber() {
        this._channel.publish('message', {
            channel: this._roomID,
            message: {
                code: 'send-wait-for-phone-number',
                userID: this._uuidUser,
                data: {msg: true, timestamp: new Date().toISOString()}
            }
        }, this._stillHere.bind(this));
    }

    _showBlockPhoneNumber() {
        if(this._waitForPhoneNumber) return ;

        this._modalService.close('share');
        this._sendWaitForPhoneNumber();

        this._modalService.showCreatedModal('broken-webrtc', showCreatedModalBrokenWebrtc(this._translate, ({phone, isoCode}) => {
            this._sendPhoneNumber({phone, isoCode});
        }), true);

        this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'pstn_shown'});
    }

    _logger(data) {
        if (this._enableConsoleLog) console.info.apply(console, arguments);
    }

    _onBrokenStream() {
        this._showBlockPhoneNumber();
        this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'rtc_not_supported'});
    }
}
